import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND_ASSETS } from "@/lib/brandAssets";

const NAV = [
  { to: "/", label: "The Club" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/subscribe", label: "Subscribe" },
  { to: "/growers", label: "Meet the Growers" },
  { to: "/territories", label: "Territory Map" },
  { to: "/become-a-grower", label: "Become a Grower" },
  { to: "/about", label: "About" },
];

export default function PublicHeader() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="border-b border-[var(--bloom-border)] bg-[var(--bloom-bg)] sticky top-0 z-40" data-testid="public-header">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 md:gap-4 min-w-0" data-testid="public-logo">
          <img
            src={BRAND_ASSETS.logo_circle}
            alt="Heritage Bloom Club"
            className="w-12 h-12 md:w-14 md:h-14 object-contain flex-shrink-0"
          />
          <div className="min-w-0">
            <div className="font-serif text-lg md:text-2xl leading-tight tracking-[0.04em] uppercase">
              Heritage Bloom Club
            </div>
            <div className="text-[8px] md:text-[9px] tracking-[0.28em] uppercase text-[var(--bloom-ink-muted)] mt-0.5">
              By Heritage Dahlias · Est 2026
            </div>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-1" data-testid="public-nav">
          {NAV.map((n) => {
            const active = n.to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(n.to);
            return (
              <Link
                key={n.to}
                to={n.to}
                className={`px-3 py-2 text-[11px] tracking-[0.18em] uppercase transition hover:text-[var(--bloom-ink)] ${
                  active ? "text-[var(--bloom-ink)] border-b border-[var(--bloom-ink)]" : "text-[var(--bloom-ink-muted)]"
                }`}
                data-testid={`nav-${n.to.replace("/", "") || "home"}`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-2">
          <Link to="/login" className="hidden md:inline-flex club-link text-xs" data-testid="header-grower-signin">
            Grower Sign In
          </Link>
          <button
            className="p-2 -mr-2 text-[var(--bloom-ink)]"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[var(--bloom-border)] bg-[var(--bloom-bg)]" data-testid="mobile-nav">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="px-2 py-2 font-serif italic text-lg text-[var(--bloom-ink)]"
              >
                {n.label}
              </Link>
            ))}
            <div className="flex flex-col gap-2 mt-4 pb-2">
              <Link to="/subscribe" onClick={() => setOpen(false)} className="bloom-btn bloom-btn-primary justify-center">Subscribe</Link>
              <Link to="/waitlist" onClick={() => setOpen(false)} className="bloom-btn bloom-btn-outline justify-center">Join the Waitlist</Link>
              <Link to="/login" onClick={() => setOpen(false)} className="bloom-btn bloom-btn-outline justify-center">Grower Sign In</Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
